import React from 'react';
import { useParams } from 'react-router-dom';
import { bands } from '../data/bands';

const Music = () => {
  const { artist } = useParams();

  // Filter bands if artist parameter is provided
  const filteredBands = artist ? bands.filter(band => band.id === artist) : bands;

  return (
    <section id="about">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2>Music</h2>
            <hr className="star-primary" />
          </div>
        </div>

        <div className="row divider">
          <div className="col-lg-12">
            <ul className="list-inline">
              <li>
                Playlists of all my currently published songs:
              </li>
              <li>
                <a href="https://soundcloud.com/philwithey/sets/songs-featuring-phil-withey?si=30b1f92c9e30476e9c847e17b3e3c4e9&utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing" target="_blank" rel="noopener noreferrer">
                  <img className="music-social" src="/img/music/social/soundcloud/orange_white_64.png" alt="SoundCloud" />
                </a>
              </li>
              <li>
                <a href="https://open.spotify.com/playlist/3Znytjr6MKcOZR3PJKXaiq?si=IxjrEx-ZQ4aZCOqsw_4QMQ" target="_blank" rel="noopener noreferrer">
                  <img className="music-social" src="/img/music/social/spotify/icon3@2x.png" alt="Spotify" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {filteredBands.map((band, index) => (
          <div key={band.id} className="row divider">
            <div className="col-lg-6">
              <h2>{band.name}</h2>
              <p className="band-subtitle">{band.yearsActive}</p>

              <div>
                <ul className="list-inline">
                  {band.soundcloud && (
                    <li>
                      <a href={`http://www.soundcloud.com/${band.soundcloud}`} target="_blank" rel="noopener noreferrer">
                        <img className="music-social" src="/img/music/social/soundcloud/orange_white_64.png" alt="SoundCloud" />
                      </a>
                    </li>
                  )}
                  {band.spotify && (
                    <li>
                      <a href={`http://open.spotify.com/artist/${band.spotify}`} target="_blank" rel="noopener noreferrer">
                        <img className="music-social" src="/img/music/social/spotify/icon3@2x.png" alt="Spotify" />
                      </a>
                    </li>
                  )}
                  {band.bandcamp && (
                    <li>
                      <a href={`http://${band.bandcamp}.bandcamp.com/releases`} target="_blank" rel="noopener noreferrer">
                        <img className="music-social" src="/img/music/social/bandcamp/bandcamp-button-square-aqua-64.png" alt="Bandcamp" />
                      </a>
                    </li>
                  )}
                </ul>
              </div>

              <p>{band.bio}</p>

              {band.profile && (
                <img className="music-profile" src={`/img/music/${band.profile}`} alt={`${band.name} profile`} />
              )}

              <h3>Lineup</h3>
              <ul>
                {band.members.map((member, memberIndex) => (
                  <li key={memberIndex}>{member.role} - {member.name}</li>
                ))}
              </ul>
            </div>
            <div className="col-lg-6">
              {band.albums.map((album, albumIndex) => (
                <div key={albumIndex}>
                  {album.cover && (
                    <img className="img-responsive album-cover" src={album.cover} alt={`${album.name} cover`} />
                  )}
                  <h3>
                    {album.name}
                    {album.releaseDate && (
                      <span className="album-releasedate"> - {album.releaseDate}</span>
                    )}
                  </h3>
                  <ul>
                    {album.tracks.map((track, trackIndex) => (
                      <li key={trackIndex}>{track}</li>
                    ))}
                    {album.incomplete && <li><i>Can't remember the rest...</i></li>}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Music; 